import { formatCustomTime } from './utils'

export enum TimeOfDay {
  Morning = 'morning',
  Afternoon = 'afternoon',
  Evening = 'evening',
  Night = 'night',
  Random = 'random',
  Custom = 'custom',
}

export interface CustomTime {
  hour: number
  minute: number
  amOrPm: 'am' | 'pm'
}

export interface DayTimeSelection {
  day: string
  timeType: TimeOfDay
  customTime?: CustomTime
}

export interface CustomScheduleConfig {
  selectedDays: string[]
  dayTimeSelections: Record<string, DayTimeSelection>
}

export interface SimpleScheduleSelectorProps {
  value: { timeOfDay: TimeOfDay; customTime?: CustomTime }
  onChange: (config: { timeOfDay: TimeOfDay; customTime?: CustomTime }) => void
  onComplete: () => void
  title?: string
}

export const TIME_OPTIONS = {
  [TimeOfDay.Morning]: {
    label: 'In the morning',
    description: 'between 9am-12pm',
  },
  [TimeOfDay.Afternoon]: {
    label: 'In the afternoon',
    description: 'between 12pm-5pm',
  },
  [TimeOfDay.Evening]: {
    label: 'In the evening',
    description: 'between 5pm-9pm',
  },
  [TimeOfDay.Night]: {
    label: 'In the night',
    description: 'between 9pm-3am',
  },
  [TimeOfDay.Random]: {
    label: 'Choose randomly for me',
    description: '',
  },
  [TimeOfDay.Custom]: {
    label: 'Let me pick time specifically',
    description: '',
  },
}

export const formatTimeSelection = (selection: DayTimeSelection): string => {
  if (selection.timeType === TimeOfDay.Custom && selection.customTime) {
    return formatCustomTime(selection.customTime)
  }
  return TIME_OPTIONS[selection.timeType].label
}
